import { NavItemType } from './addJobPost.type';

export const navItems: NavItemType[] = [
  {
    label: 'Role / Skills',
    eventKey: 'skill',
    icon: 'book'
  },
  {
    label: 'Contact',
    icon: 'user',
    eventKey: 'contact'
  },
  {
    label: 'Application',
    icon: 'book-open',
    eventKey: 'application'
  },
  {
    label: 'Others',
    icon: 'archive',
    eventKey: 'others'
  }
];

export const tab = {
  basic: 'basic',
  skill: 'skill',
  contact: 'contact',
  application: 'application',
  others: 'others'
};

export const tabFields = {
  [tab.basic]: [
    'title',
    'desc',
    'companyName',
    'jobLocation',
    'employmentType',
    'salaryRange',
    'experience'
  ],
  [tab.skill]: ['role', 'skills'],
  [tab.contact]: ['contactPersonName', 'contactPersonEmail'],
  [tab.application]: ['deadline', 'linkOrEmail', 'numberOfOpenings'],
  [tab.others]: []
};

export type TabValues = (typeof tab)[keyof typeof tab];

export const validateTab = (fields: string[], touchedFields: string[]) => {
  const status: Record<TabValues, boolean> = {
    [tab.basic]: false,
    [tab.skill]: false,
    [tab.application]: false,
    [tab.contact]: false,
    [tab.others]: false
  };

  fields.forEach(field => {
    for (const key in status) {
      if (Object.prototype.hasOwnProperty.call(status, key)) {
        const availableFields = tabFields[key];
        if (availableFields.includes(field) && touchedFields.includes(field)) {
          status[key] = true;
        }
      }
    }
  });

  return status;
};
